import React from "react";
import { Container, Header, Row, Title, Portfolio } from "../components";
import WorkContainer from "../containers/Works";
import works from "../fixtures/Portfolio.json";

const PortfolioPage: React.FC = () => (
  <Portfolio>
    <Container>
      <Row>
        <Header>
          <Title>projects</Title>
        </Header>
      </Row>
      <Row>
        {works.map((item) => (
          <WorkContainer work={item} />
        ))}
      </Row>
    </Container>
  </Portfolio>
);

export default PortfolioPage;
